import { formatAmount } from "grid/columns";
import * as http from "utils/http";
import * as notifications from "utils/notifications";

interface Fee {
  amount: number;
}

interface FeeRequest {
  payment_amount: number;
  state?: string;
}

export class FeeManager {
  private feesUrl: string;
  private origFeeLabelText: string;
  private waiveFeeCheckbox: HTMLInputElement;
  private waiveFeeLabel: HTMLLabelElement;

  constructor(waiveFeeCheckbox: HTMLInputElement, feesUrl: string) {
    this.feesUrl = feesUrl;
    this.waiveFeeCheckbox = waiveFeeCheckbox;
    this.waiveFeeLabel = document.querySelector(`label[for="${waiveFeeCheckbox.id}"]`);
    this.origFeeLabelText = this.waiveFeeLabel.textContent;
  }

  isWaiveFee(): boolean {
    return this.waiveFeeCheckbox.checked;
  }

  async clearFee() {
    this.updateFeeLabel("");
  }

  async refreshFee(request: FeeRequest) {
    const response = await http.httpGet(this.feesUrl, request);

    if (response.ok) {
      const data = await response.json();
      const record = data.records[0] as Fee;
      if (record) {
        this.updateFeeLabel(formatAmount(record.amount));
      } else {
        this.updateFeeLabel("");
      }
    } else {
      const data = await response.json();
      notifications.alert(data.error);
    }
  }

  private updateFeeLabel(amountText: string) {
    this.waiveFeeLabel.textContent = this.origFeeLabelText.replace("$", `$${amountText}`);
  }
}
